import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const appointmentService = {
  list: async (params = {}) => {
    const response = await api.get('/appointments', { params });
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/appointments', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/appointments/${id}`, data);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/appointments/${id}`);
    return response.data;
  },
};

export default appointmentService;
